import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Icon, {ICONS} from '../Icon';

const NodeItem = ({id: nodeId, properties}) => (
    <Link to={`/browse/node/${nodeId}`} className="node-item">
        <h2><Icon icon={ICONS.NODE} /> {nodeId}</h2>
        <small><Icon icon={ICONS.PROPERTIES} /> <strong>{properties.length}</strong> properties</small>
    </Link>
);

NodeItem.propTypes = {
    id: PropTypes.string.isRequired,
    properties: PropTypes.array.isRequired,
};

export default NodeItem;
